<template>
  <tr>
    <td>
      <p class="has-text-weight-bold">
        {{ section.standard.name }}
      </p>
      <p class="has-text-grey">{{ section.title }}</p>
    </td>
    <td>{{ section.setting.secure_setting }}</td>
    <td>
      <span
       :class="{
         'has-text-success': outcome === 'Pass',
         'has-text-danger': outcome === 'Fail',
       }">{{ outcome }}</span>
    </td>
  </tr>
</template>
<script>
import { find } from 'lodash'

export default {

  props: {
    section: {
      type: Object,
      default: () => ({})
    },
    results: {
      type: Array,
      default: () => ([])
    }
  },

  computed: {
    outcome() {
      let result = find(this.results, result => result.standard === this.section.id)
      return result ? result.outcome : '--'
    }
  }
}
</script>